<!--I have removed all conditions from here because all Coming-soon scenarions are
  handleled by routes and guards-->
<div #scrollElement></div>

<header id="main-header" [ngClass]="{ 'no-animation': noAnimation }">
    <app-header></app-header>
</header>

<main id="main-content">
    <ng-container *ngIf="showCountrySelectionPanel()">
        <app-country-selector></app-country-selector>
    </ng-container>
    <router-outlet *ngIf="!showCountrySelectionPanel()"></router-outlet>
</main>

<ng-container *ngIf="showLoginForNonProdEnviorment">
    <app-generic-login-page></app-generic-login-page>
</ng-container>

<div *ngIf="showToast">
    <app-toast
        [message]="toastMessage"
        [toastType]="toastType"
        [position]="position"
        [leftPosition]="leftPosition"
    >
    </app-toast>
</div>

<div *ngIf="showNotification">
    <app-notification></app-notification>
</div>

<footer>
    <app-footer (scrollToTop)="scrollTop()"></app-footer>
</footer>

<div class="language-picker">
    <ng-container *ngIf="showLangPicker">
        <app-language-selection-page></app-language-selection-page>
    </ng-container>
</div>

<div class="lightbox">
    <ng-container *ngIf="showLightBox">
        <app-lightbox></app-lightbox>
    </ng-container>
</div>
